import React, { useState } from "react"
import { AddedReason, Container, Label, LabelWrapper, Wrapper } from "./Reason.styled"
import Input from "../../../../Ui/Form/Input"
import PrimaryButton from "../../../../Ui/Buttons/PrimaryButton"
import { InputReason, OrderCompensation } from "@lib/types/generated/graphql-types"
import { useMutation } from "@apollo/client"
import { ReactComponent as TrashIcon } from "../../../../../images/icons/trash-can.svg"
import { Loader } from "../../../../Ui/Loader"
import { theme } from "../../../../../theme"
import { ReactComponent as DownIcon } from "images/icons/chevron-down.svg"
import { ReactComponent as UpIcon } from "images/icons/chevron-up.svg"
import UPDATE_COMPENSATION from "../../../../../graphql/mutations/order/compensation/UpdateCompensation"
import { getCompensationInput } from "../Helpers/helpers"
import { handleErrorMessages } from "helpers/errors"

type Props = {
  compensation: OrderCompensation
  refetch: () => void
}

const Reason = ({ compensation, refetch }: Props) => {
  const [reason, setReason] = React.useState<InputReason>({ cause: "", code: "" })
  const [expanded, setExpanded] = useState<boolean>(false)

  const updateCause = (cause: string) => setReason({ ...reason, cause: cause })
  const updateCode = (code: string) => setReason({ ...reason, code: code })

  const [updateCompensation, { loading }] = useMutation(UPDATE_COMPENSATION, {
    onCompleted: () => refetch(),
    onError: (error) => {
      handleErrorMessages(error)
    }
  })

  const updateReason = () => {
    updateCompensation({
      variables: {
        compensationId: compensation.id,
        input: {
          ...getCompensationInput(compensation),
          ...(reason.cause && reason.code && { reason: reason })
        }
      }
    })
  }

  const removeReason = () => {
    updateCompensation({
      variables: {
        compensationId: compensation.id,
        input: {
          ...getCompensationInput(compensation),
          reason: null
        }
      }
    })
  }

  if (compensation?.reason)
    return (
      <Wrapper>
        <Label>Reason</Label>
        <AddedReason>
          <div>
            <span>
              <b>Cause:</b> {compensation?.reason.cause}
            </span>
            <span>
              <b>Code:</b> {compensation?.reason.code}
            </span>
          </div>
          {loading ? (
            <Loader color={theme.colors.grey} />
          ) : (
            <TrashIcon onClick={removeReason}></TrashIcon>
          )}
        </AddedReason>
      </Wrapper>
    )

  return (
    <Wrapper>
      <LabelWrapper onClick={() => setExpanded(!expanded)}>
        <Label>Reason</Label>
        {expanded ? <UpIcon/> : <DownIcon />}
      </LabelWrapper>
      {expanded && (
        <Container addedReason={!!compensation?.reason}>
          {compensation?.reason ? (
            <AddedReason>
              <div>
                <span>
                  <b>Cause:</b> {compensation?.reason.cause}
                </span>
                <span>
                  <b>Code:</b> {compensation?.reason.code}
                </span>
              </div>
              {loading ? (
                <Loader color={theme.colors.grey} />
              ) : (
                <TrashIcon onClick={removeReason}></TrashIcon>
              )}
            </AddedReason>
          ) : (
            <>
              <Input
                name={"cause"}
                placeholder={"Cause"}
                removePaddingBottom={true}
                onChange={(e: React.FormEvent<HTMLInputElement>) =>
                  updateCause(e.currentTarget.value)
                }
              />
              <Input
                name={"code"}
                placeholder={"Code"}
                removePaddingBottom={true}
                onChange={(e: React.FormEvent<HTMLInputElement>) =>
                  updateCode(e.currentTarget.value)
                }
              />
              <PrimaryButton
                disabled={!reason.cause || !reason.code}
                loading={loading}
                handleClick={updateReason}
              >
                Add
              </PrimaryButton>
            </>
          )}
        </Container>
      )}
    </Wrapper>
  )
}

export default Reason
